import { BlockNoteSchema, defaultBlockSpecs } from "@blocknote/core";
import { aiDocumentFormats } from "@blocknote/xl-ai";
import type { JSONSchema7 } from "ai";

const { codeBlock, ...blockSpecs } = defaultBlockSpecs;
void codeBlock;

export const scriptEditorSchema = BlockNoteSchema.create({ blockSpecs });

const BLOCK_HTML =
  "One HTML element: p, h1, h2, h3, ul, ol, or blockquote. Code blocks are disabled. Do not use pre or code.";

const htmlTools = aiDocumentFormats.html.getStreamToolsProvider();

function asObjectSchema(value: unknown): JSONSchema7 | undefined {
  if (!value || typeof value !== "object" || Array.isArray(value)) return undefined;
  return value as JSONSchema7;
}

function withoutCodeBlocks(schema: JSONSchema7): JSONSchema7 {
  const properties = schema.properties;
  if (!properties) return schema;
  const next = { ...properties };
  const blocks = asObjectSchema(next.blocks);
  if (blocks) {
    const items = asObjectSchema(blocks.items) ?? {};
    next.blocks = { ...blocks, items: { ...items, description: BLOCK_HTML } };
  }
  const block = asObjectSchema(next.block);
  if (block) next.block = { ...block, description: BLOCK_HTML };
  return { ...schema, properties: next };
}

export const scriptStreamTools = {
  getStreamTools: (...args: Parameters<typeof htmlTools.getStreamTools>) => {
    const tools = htmlTools.getStreamTools(...args);
    for (const tool of tools) tool.inputSchema = withoutCodeBlocks(tool.inputSchema);
    return tools;
  },
};
